module.exports = __webpack_public_path__ + "img/record_item_sel.62372a73.png";